module.exports = __webpack_public_path__ + "assets/48.jpg?8f5913fa361d9542860671fca63bb2a0";